<template>
  <v-container fluid>
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text v-if="formData.related_gdz_message">
          <div style="font-size: 17px; color: red; font-weight: 700" v-html="formData.related_gdz_message"></div>
        </v-card-text>
        <v-card-text class="mt-3">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-button
                v-if="showRejectBtn"
                class="mr-1"
                title="Atmesti"
                :loading="loading"
                @click.native="openModal('reject')"
                color="primary"
                icon="atšaukti"
              />
              <el-button
                v-if="showAttributeBtn"
                class="mr-1"
                color="primary"
                icon="failas"
                title="Įvesti požymį"
                @click.native.stop="openModal('attribute')"
                :loading="loading"
              />
              <el-button
                v-if="showUnsubscribeBtn"
                class="mr-1"
                color="danger"
                icon="atšaukti"
                title="Išregistruoti"
                @click.native.stop="openModal('unsubscribe')"
                :loading="loading"
              />
              <el-button
                v-if="showRegisterBtn"
                class="mr-1"
                color="primary"
                icon="failas"
                title="Įregistruoti"
                @click.native.stop="openModal('register')"
                :loading="loading"
              />
                <el-button
                v-if="showIregInactiveBtn"
                class="mr-1"
                color="danger"
                title="Išregistruoti / Įvesti požymį"
                @click.native.stop="openIregInactiveModal()"
                :loading="loading"
              />

              <span v-if="showInfoAboutmarkedDocuments && selectableDocumentCount">
                <strong style="color: red">Ar nurodėte dokumentus, kurie bus atvaizduojami išraše?</strong>
              </span>
            </v-col>
            <v-col cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Dokumento informacija') }}</h2>
              <el-simple-table v-if="!loading" :items="documentInfoList" />
            </v-col>
          </v-row>
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Kiti duomenys') }}</h2>
              <el-simple-table :items="otherDataList" />
            </v-col>
          </v-row>

          <!-- JA Išdavęs su atstovais -->
          <v-row v-if="!reloadPersons">
            <v-col cols="12" v-if="showProcuratorsTable">
              <div class="pt-4">
              <!-- title  -->
              <h3 class="mb-1" style="display: flex">{{ $t('JA, išdavęs prokūrą')}}</h3>
              <!-- add button  -->
              <v-data-table
                class="mb-4 custom-table"
                :loading="loading"
                :headers="headersProcurator.filter(item => item.value !== 'person_document_kind_title_lt')"
                :items="formData.document_info.pro_principals || {}"
                :hide-default-footer="true"
                :items-per-page="1000"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal'),
                }"
              >
              <!-- custom templates -->
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.display_amn }}</td>
                  <td>{{ item.code || item.iltu_code }}</td>
                  <td>{{ item.fullname }}</td>
                  <td></td>
                  <td>{{ item.other_info }}</td>
                  <td><person-contact-row :item="item"></person-contact-row></td>
                  <td></td>
                </tr>
                  <template v-for="(representer, index) in item.jur_representers">
                    <tr :key="`${item.id}-${index}-representer`">
                      <td>{{ representer.display_amn }}</td>
                      <td style="white-space: nowrap">
                        <v-icon>mdi-circle-small</v-icon>
                        <span>{{ representer.code }}</span>
                      </td>
                      <td>{{ representer.fullname }}</td>
                      <td></td>
                      <td v-if="representer.other_info">
                        {{
                          `${item.fullname} ${$t('atstovas')} (${
                            representer.other_info
                          })`
                        }}
                      </td>
                      <td v-else>{{ `${item.fullname} ${$t('atstovas')}` }}</td>
                      <td><person-contact-row :item="representer"></person-contact-row></td>
                      <td>
                        <template>
                          <div class="nowrap">
                            <el-table-action
                              :item="setRepresenter(representer)"
                              @fixPerson="fixPerson(representer)"
                            />
                          </div>
                        </template>
                      </td>
                    </tr>
                  </template>
                </template>
              </v-data-table>
            </div>
            </v-col>
          </v-row>

          <!-- Prokuristai -->
          <v-row v-if="!reloadPersons">
            <v-col cols="12" v-if="showProcuratorsTable">
              <div class="pt-4">
              <!-- title  -->
              <h3 class="mb-1" style="display: flex">
                {{ $t('Prokuristai')
                }}<el-tooltip
                  tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Prokuristai"
                  subTitle
                ></el-tooltip>
              </h3>
              <!-- add button  -->
              <v-data-table
                class="mb-4 custom-table"
                :loading="loading"
                :headers="headersProcurator"
                :items="formData.document_info.procurators || {}"
                :hide-default-footer="true"
                :items-per-page="1000"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal'),
                }"
              >
                <template #[`item.actions`]="{ item }">
                  <div class="nowrap">
                    <el-table-action
                      :item="setProcurator(item)"
                      @fixPerson="fixPerson(item)"
                      @showPersonDocument="showPersonDocument(item)"
                    />
                  </div>
                </template>
                <template #[`item.contact_row`]="{ item }">
                  <td><person-contact-row :item="item"></person-contact-row></td>
                </template>
                <template #[`item.person_document_kind_title_lt`]="{ item }">
                  <td>{{ item.person_document_kind_title_lt || '' }}</td>
                </template>
              </v-data-table>
            </div>
            </v-col>
          </v-row>

          <!-- NTPI Įgaliotojai -->
          <v-row v-if="!reloadPersons">
            <v-col cols="12" v-if="showNtpiPersonTable">
              <div class="pt-4">
              <!-- title  -->
              <h3 class="mb-1" style="display: flex">{{ formData.parent_id ? $t('Perįgaliotojai') : $t('Įgaliotojai')}}</h3>
               <el-checkbox
                  v-if="formData.document_info.principals.length > 1"
                  disabled
                  class="mt-0 mb-1"
                  style="width: fit-content"
                  label="Veikia kartu"
                  v-model="formData.document_info.principals_together"
                />
              <v-data-table
                class="mb-4 custom-table"
                :loading="loading"
                :headers="headersNtpiPersons"
                :items="formData.document_info.principals || {}"
                :hide-default-footer="true"
                :items-per-page="1000"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal'),
                }"
              >
              <!-- custom templates -->
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.display_amn }}</td>
                  <td>{{ item.code || item.iltu_code }}</td>
                  <td>{{ item.fullname }}</td>
                  <td>{{ item.other_info }}</td>
                  <td><person-contact-row :item="item"></person-contact-row></td>
                  <td>{{ item.person_document_kind_title_lt || '' }}</td>
                  <td>
                    <template>
                        <div class="nowrap">
                          <el-table-action
                            :item="setRepresenter(item)"
                            @fixPerson="fixPerson(item)"
                            @showPersonDocument="showPersonDocument(item)"
                          />
                        </div>
                      </template>
                  </td>
                </tr>
                  <template v-for="(representer, index) in item.jur_representers">
                    <tr :key="`${item.id}-${index}-representer`">
                      <td>{{ representer.display_amn }}</td>
                      <td style="white-space: nowrap">
                        <v-icon>mdi-circle-small</v-icon>
                        <span>{{ representer.code }}</span>
                      </td>
                      <td>{{ representer.fullname }}</td>
                      <td v-if="representer.other_info">
                        {{
                          `${item.fullname} ${$t('atstovas')} (${
                            representer.other_info
                          })`
                        }}
                      </td>
                      <td v-else>{{ `${item.fullname} ${$t('atstovas')}` }}</td>
                      <td>{{ item.person_document_kind_title_lt || '' }}</td>
                      <td>
                        <template>
                          <div class="nowrap">
                            <el-table-action
                              :item="setRepresenter(representer)"
                              @fixPerson="fixPerson(representer)"
                              @showPersonDocument="showPersonDocument(representer)"
                            />
                          </div>
                        </template>
                      </td>
                    </tr>
                  </template>
                </template>
              </v-data-table>
            </div>
            </v-col>
          </v-row>

          <!-- NTPI Įgaliotiniai -->
          <v-row v-if="!reloadPersons">
            <v-col cols="12" v-if="showNtpiPersonTable">
              <div class="pt-4">
              <!-- title  -->
              <h3 class="mb-1" style="display: flex">{{ formData.parent_id ? $t('Perįgaliotiniai') : $t('Įgaliotiniai')}}</h3>
                <template v-if="formData.parent_id">
                  <el-checkbox
                    v-if="formData.document_info.representitives.length > 1"
                    disabled
                    class="mt-0 mb-1"
                    style="width: fit-content"
                    label="Veikia kartu"
                    v-model="formData.document_info.sub_representitives_together"
                  />
                </template>
                <template v-else>
                  <el-checkbox
                    v-if="formData.document_info.representitives.length > 1"
                    disabled
                    class="mt-0 mb-1"
                    style="width: fit-content"
                    label="Veikia kartu"
                    v-model="formData.document_info.representitives_together"
                  />
                </template>
              <v-data-table
                class="mb-4 custom-table"
                :loading="loading"
                :headers="headersNtpiPersons"
                :items="formData.document_info.representitives || {}"
                :hide-default-footer="true"
                :items-per-page="1000"
                :header-props="{
                  sortByText: $t('Rūšiuoti pagal'),
                }"
              >
              <!-- custom templates -->
              <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.display_amn }}</td>
                    <td>{{ item.code || item.iltu_code }}</td>
                    <td>{{ item.fullname }}</td>
                    <td>{{ item.other_info }}</td>
                    <td><person-contact-row :item="item"></person-contact-row></td>
                    <td>{{ item.person_document_kind_title_lt || '' }}</td>
                    <td>
                      <template>
                          <div class="nowrap">
                            <el-table-action
                              :item="setRepresenter(item)"
                              @fixPerson="fixPerson(item)"
                              @showPersonDocument="showPersonDocument(item)"
                            />
                          </div>
                        </template>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            </v-col>
          </v-row>

          <v-row class="mb-0 pb-0">
            <v-col v-if="showJournalPdf" class="pb-0" cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Pranešimas / prašymas') }}</h2>
              <el-PDF-viewer download :file="files.in_journal_file" />
            </v-col>
            <v-col v-if="showMandatePdf" class="pb-0" cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Aktualūs duomenys') }}</h2>
              <el-PDF-viewer download :file="pdfFile" />
            </v-col>
            <v-col v-if="showFiles" class="pb-0" cols="12" md="6">
              <h2 class="ml-4 mb-3">{{ $t('Objekto dokumentai') }}</h2>
              <el-simple-table :items="filesList" />
            </v-col>
            <template v-if="attachments.length">
             <v-col>
              <!-- title  -->
              <h3 class="mb-1" style="display: flex">{{ $t('Prašymo dokumentai') }}</h3>
              <v-card class="mb-1" outlined>
                <!-- form  -->
                <v-card-text class="pb-0">
                  <!-- add button  -->
                  <v-data-table
                    class="mb-4 custom-table"
                    :loading="loading"
                    :headers="headers"
                    :items="formData.attachments"
                    :hide-default-footer="true"
                    :header-props="{
                      sortByText: $t('Rūšiuoti pagal'),
                    }"
                  >
                    <!-- custom templates -->
                    <template #[`item.size`]="{ item }">
                    <span>{{ getItemSize(item) }}</span>
                    </template>
                    <!--  -->
                    <template #[`item.actions`]="{ item }">
                      <div class="nowrap">
                        <el-table-action
                          :item="setDocumentsItem(item)"
                          @downloadItem="download(item)"
                        />
                      </div>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-col>
            </template>
          </v-row>

          <v-row class="mb-0 pb-0" v-if="showSelectionTable">
            <v-col>
              <statement-files
                :objectId="formData.mandate_id"
                :inJournalId="getId"
                :canChange="true"
                @selectedDocumentsChanged="selectedDocumentsChanged"
                @setDocumentCount="setDocumentCount"
              />
            </v-col>
          </v-row>

          <v-row class="mb-0 pb-0" v-else-if="formData.document_info && formData.document_info.statement_files.length && isIvykdytas">
            <v-col>
              <h3>Su šiuo dokumentu pasirinkti failai, kurie turi būti rodomi išraše:</h3>
              <div v-for="(document, index) in formData.document_info.statement_files" :key="index">
                {{ document }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
           <!-- actions  -->
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
           <el-button
            class="mr-2"
            tile
            @click.native="back()"
            :loading="loading"
            title="Atgal"
          />

        </v-row>
      </v-card-actions>
      </form>
    </v-card>
    <fix-person-form
        v-if="showFixPerson"
        v-model="showFixPerson"
        :modalType="modalType"
        :person="selectedProcurator"
        @addPersonData="updatePerson"
        :journalData="isNtpi"
        addRaw
        mandate
      />
    <modal-document-action
      v-if="showDocumentAction"
      v-model="showDocumentAction"
      :modalType="modalType"
      :basis="basis"
      :basisText="basisText"
      :injournalId="getId"
      :mandatePersonData="getMandatePerson"
      :documentKind="formData.document_info.document_kind"
      :number="formData.document_info.journal_no"
      @confirmDocumentAction="confirmDocumentAction"
      :requestLoading="requestLoading"
    />
     <modal-ireg-inactive-action
      v-if="showIregInactiveAction"
      :injournal-id="getId"
      :form-data="iregInactiveData"
      :request-loading="requestLoading"
      :documentKind="formData.document_info.document_kind"
      :basis="basis"
      :basisText="basisText"
      @close-modal="closeIregInactiveModal"
    />
    <modal-custom
      title="Pranešimas"
      :text="getDuplicateMsg"
      trueText="Tęsti"
      falseText="ATŠAUKTI"
      :loading="loading"
      v-model="showDuplicateModal"
      mid
      positive-choice-only
      @confirmData="closeDuplicateModal"
    />
    <modal-person-document
      v-if="showPersonDocumentModal"
      v-model="showPersonDocumentModal"
      :item="selectedPersonDocument"
      :readonly="!canEditPersonDocument"
      upload-mode="instant"
      :in-journal-latest-status-date="inJournalLatestStatusDate"
      :in-journal-id="getId"
      @files-uploaded="handlePersonDocumentFilesUploaded"
      @file-removed-from-backend="handlePersonDocumentFileRemoved"
    />
  </v-container>
</template>

<script>
import ModalDocumentAction from '@/components/modals/ModalDocumentAction'
import ModalIregInactiveAction from '@/components/modals/ModalIregInactiveAction'
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
import InJournalTypes from '@/components/constants/inJournalTypes'
import InJournalStatus from '@/components/constants/inJournalStatus'
import FixPersonForm from './FixPersonForm.vue'
import StatementFiles from '@/components/tables/StatementFiles.vue'
import PersonContactRow from '@/components/iregTableRows/PersonContactRow.vue'
import ModalCustom from '@/components/modals/ModalCustom'
import ModalPersonDocument from '@/components/modals/ModalPersonDocument.vue'

export default {
  name: 'JournalReveivedDataForm',
  components: {
    ModalDocumentAction,
    ModalIregInactiveAction,
    FixPersonForm,
    StatementFiles,
    PersonContactRow,
    ModalCustom,
    ModalPersonDocument
  },
  mixins: [math],
  data() {
    return {
      showDuplicateModal: false,
      reloadPersons: false,
      loading: false,
      showFixPerson: false,
      formData: {},
      showDocumentAction: false,
      requestLoading: false,
      modalType: null,
      selectedProcurator: {},
      selectedPersonDocument: {},
      showPersonDocumentModal: false,
      files: {
        in_journal_file: {},
        mandate_file: {},
      },
      pdfFile: {},
      mainFiles: [],
      attachments: [],
      selectedStatementDocuments: [],
      selectableDocumentCount: 0,
      showIregInactiveAction: false,
      iregInactiveData: {}
    }
  },
  created() {
    this.getData()
  },
  computed: {
    ...mapGetters(['sortParams']),
    getDuplicateMsg(){
      return this.formData.duplicates_msg || ''
    },
    isDuplicate(){
      return this.formData.is_duplicate
    },
    showInfoAboutmarkedDocuments() {
      return this.formData.document_info?.status == InJournalStatus.PRIIMTAS
    },
    isNtpi() {
      return [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(this.formData.document_info.in_journal_type)
    },
    isIvykdytas() {
      return this.formData.document_info.status == InJournalStatus.IVYKDYTAS
    },
    basis() {
      return this.formData.document_info?.basis
    },
    basisText() {
      return this.formData.document_info?.basis_text
    },
    showSelectionTable() {
      return this.formData.document_info?.status == InJournalStatus.PRIIMTAS
    },
    canEditPersonDocument() {
      return this.formData.document_info?.status === InJournalStatus.PRIIMTAS
    },
    showProcuratorsTable() {
      return this.formData.document_info?.in_journal_type == InJournalTypes.PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_IREGISTRAVIMO
        && this.formData.document_info?.document_kind === 'PP'
    },
    showProPrincipalTable() {
      return this.formData.document_info?.in_journal_type == InJournalTypes.PROKURA_ISDAVUSIO_JA_DEL_PROKUROS_IREGISTRAVIMO
        && this.formData.document_info?.receive_mode === 308
        && this.formData.document_info?.document_kind === 'PP'
    },
    showNtpiPersonTable() {
      return [InJournalTypes.PRANESIMAS_APIE_PATVIRTINIMA, InJournalTypes.PRANESIMAS_APIE_PAKEITIMA].includes(this.formData.document_info?.in_journal_type) && this.formData.document_info?.document_kind === 'NTPI'
    },
    filesList() {
      let arrOfFiles = []
      this.mainFiles.map((file) => {
        let fileObj = {}
        fileObj.fileData = file.file
        fileObj.title = file.original_name
        arrOfFiles.push(fileObj)
      })
      return arrOfFiles
    },
    showFiles() {
      return this.mainFiles && Object.keys(this.mainFiles).length != 0
    },
    showAttributeBtn() {
      return this.formData.canIregEnterBasis || false
    },
    showRejectBtn() {
      return this.formData.canIregReject || false
    },
    showUnsubscribeBtn() {
      return this.formData.canIregDeregister || false
    },
    showRegisterBtn() {
      return this.formData.canIregRegister || false
    },
    showIregInactiveBtn() {
      return this.formData.canIregInactive
    },
    getJournalType() {
      return this.formData.document_info?.in_journal_type
    },
    showJournalPdf() {
      return this.formData.document_info?.in_journal_file || false
    },
    showMandatePdf() {
      return Object.keys(this.pdfFile).length != 0
    },
    getMandatePerson() {
      return this.formData.document_info?.mandate_person || false
    },
    inJournalLatestStatusDate() {
      // Use the document received date as the reference for file deletion limitations
      return this.formData.document_info?.date_received || null
    },
    headersProcurator() {
      return [
        {
          text: this.$t('AMN ID'),
          align: 'start',
          value: 'display_amn',
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'selectedCode',
        },
        {
          text: this.$t('Vardas pavardė'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Fizinio asmens identifikavimo kodas užsienio valstybėje'),
          align: 'start',
          value: 'foreigner_code',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Asmens dokumentas'),
          align: 'start',
          value: 'person_document_kind_title_lt',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    headersNtpiPersons() {
      return [
        {
          text: this.$t('AMN ID'),
          align: 'start',
          value: 'display_amn',
        },
        {
          text: this.$t('Asmens/ILTU kodas'),
          align: 'start',
          value: 'selectedCode',
        },
        {
          text: this.$t('Vardas pavardė'),
          align: 'start',
          value: 'fullname',
          width: '18rem',
        },
        {
          text: this.$t('Kita informacija'),
          align: 'start',
          value: 'other_info',
        },
        {
          text: this.$t('Kontaktai'),
          align: 'start',
          value: 'contact_row',
        },
        {
          text: this.$t('Asmens dokumentas'),
          align: 'start',
          value: 'person_document_kind_title_lt',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    documentInfoList() {
      return [
        {
          title: 'Reg. Nr. gautų dokumentų žurnale',
          value: this.formData.document_info?.journal_no || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Reg nr gautų dokumentų žurnale"
        },
        {
          title: 'Gauto dokumento pavadinimas',
          value: this.formData.document_info?.in_journal_type || '',
          enumName: 'inJournalType',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Gauto dokumento pavadinimas"
        },
        {
          title: 'Gavimo data ir laikas',
          value: this.formData.document_info?.date_received || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Gavimo data ir laikas"
        },
        {
          title: 'Gavimo būdas',
          value: this.formData.document_info?.receive_mode || '',
          enumName: 'receiveMode',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Gavimo būdas"
        },
        {
          title: 'Būsena',
          value: this.formData.document_info?.status || '',
          enumName: 'journalType',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Būsena"
        },
      ]
    },
    otherDataList() {
      return [
        {
          title: 'Įgaliojimo / prokūros ID',
          value: this.formData.document_info?.mandate_code || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Įgaliojimo ID"
        },
        {
          title: 'Įregistravimo data',
          value: this.formData.document_info?.mandate_registration_date || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Įregistravimo data"
        },
        {
          title: 'Išregistravimo data',
          value: this.formData.document_info?.mandate_deregistration_date || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Išregistravimo data"
        },
        {
          title: 'Požymio įvedimo data',
          value: this.formData.document_info?.data_entered_date || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Duomenų įrašymo data",
          hide: !this.formData.document_info?.data_entered_date,
        },
        {
          title: 'Įgaliojimo / prokūros sustabdymo data',
          value: this.formData.document_info?.suspension_date || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Duomenų įrašymo data",
          hide: !this.formData.document_info?.suspension_date,
        },
        {
          title: 'Tvarkė',
          value: this.formData.document_info?.registrar || '',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Tvarkė"
        },
        {
          title: 'Pagal teismo pranešimą',
          value: this.formData.document_info?.parent_journal,
          hide: !this.formData.document_info?.parent_journal,
        },
        {
          title: 'Užsienyje patvirtinto įgaliojimo, kuris buvo perįgaliotas, duomenys',
          value: ' ',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Įgaliojimo patvirtinimo data',
          value: this.formData.document_info?.foreign_mandate_confirm_date || '',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Registracijos numeris',
          value: this.formData.document_info?.foreign_mandate_notarial_no || '',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Užsienio valstybės pareigūno, patvirtinusio sudarytą įgaliojimą, pareigos, vardas, pavardė',
          value: this.formData.document_info?.foreign_mandate_confirm_person || '',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Pažymos (Apostille) data',
          value: this.formData.document_info?.apostille_date || '',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Pažymos (Apostille) numeris',
          value: this.formData.document_info?.apostille_number || '',
          hide: !this.formData.document_info?.from_foreign_mandate,
        },
        {
          title: 'Panaikinimo data',
          value: this.formData.document_info?.basis_date || '',
          hide: this.getJournalType != '408' || this.formData.document_info?.status == '803',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Panaikinimo data"
        },
        {
          title: 'Panaikinimo požymis',
          value: this.formData.document_info?.basis || '',
          hide: this.getJournalType != '408' || this.formData.document_info?.status == '803',
          enumName: 'inJournalBasis',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Panaikinimo požymis"
        },
        {
          title: 'Atsisakymo data',
          value: this.formData.document_info?.basis_date || '',
          hide: this.getJournalType != '409' || this.formData.document_info?.status == '803',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Atsisakymo data"
        },
        {
          title: 'Atsisakymo požymis',
          value: this.formData.document_info?.basis || '',
          hide: this.getJournalType != '409' || this.formData.document_info?.status == '803',
          enumName: 'inJournalBasis',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Atsisakymo požymis"
        },
        {
          title: 'Pasibaigimo data',
          value: this.formData.document_info?.basis_date || '',
          hide: !['406', '415'].includes(this.getJournalType),
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Pasibaigimo data"
        },
        {
          title: 'Pasibaigimo pagrindas',
          value: this.formData.document_info?.basis || '',
          hide: !['406', '415'].includes(this.getJournalType),
          enumName: 'inJournalBasis',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Pasibaigimo pagrindas"
        },
        {
          title: 'Išregistravimo data',
          value: this.formData.document_info?.solved_at || '',
          hide: !['406', '415'].includes(this.getJournalType),
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Išregistravimo data"
        },
        {
          title: 'Atsisakymo įvykdyti data',
          value: this.formData.document_info?.solved_at || '',
          hide: this.formData.document_info?.status != '803' && this.formData.document_info?.status != '816',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Atmetimo data"
        },
        {
          title: 'Atsisakymo įvykdyti priežastis',
          value:  this.$i18n.locale === 'lt' ? this.formData.document_info?.reject_reason_lt : this.formData.document_info?.reject_reason_en || '',
          hide: this.formData.document_info?.status != '803' && this.formData.document_info?.status != '816',
          tooltip: "Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Atmetimo priežastis"
        },
        {
          title: 'PAS prašymo numeris',
          value: this.formData.document_info?.pas_number,
          hide: !this.formData.document_info?.pas_number
        }
      ]
    },
    getId() {
      return this.$route.params.id || null
    },
    // Documents table
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'original_filename',
        },
        {
          text: this.$t('Dydis'),
          align: 'start',
          value: 'size',
        },
        {
          text: this.$t('Įkėlimo data'),
          align: 'start',
          value: 'created_at',
        },
      ]
    },
  },
  methods: {
    closeIregInactiveModal(update){
      update && this.getData();
      this.showIregInactiveAction = false
      this.iregInactiveData = null
    },
    openIregInactiveModal(){
      this.requestLoading = true
      this.$axios
        .post(`in-journals/${this.getId}/available-actions-nirvar`)
        .then((res) => {
          this.showIregInactiveAction = true
          this.iregInactiveData = res.data.availableActions
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        }).finally(() => {
          this.requestLoading = false
        })
    },
    setDocumentCount(count) {
      this.selectableDocumentCount = count
    },
    selectedDocumentsChanged(documentList) {
      this.selectedStatementDocuments = documentList;
    },
    back() {
      this.$router.push({ name: 'journalReceived' })
    },
    fixPerson(person) {
      this.selectedProcurator = person
      this.showFixPerson = true
    },
    hasAnyPersonDocument(person) {
      const hasDocs = person.person_documents && Array.isArray(person.person_documents) && person.person_documents.length > 0
      const hasFiles = person.person_document_files && (Array.isArray(person.person_document_files) ? person.person_document_files.length > 0 : true)
      const hasKind = !!(person.person_document_kind_id || person.person_document_kind_title_lt)
      const hasDate = !!person.person_document_date
      const hasNumber = !!(person.person_document_number && String(person.person_document_number).trim())
      return hasDocs || hasFiles || hasKind || hasDate || hasNumber
    },
    setProcurator(procurator) {
      procurator.canDelete = false
      procurator.showPersonDocument = this.hasAnyPersonDocument(procurator)
      return procurator
    },
    setRepresenter(representer){
      representer.canDelete = false
      representer.showPersonDocument = this.hasAnyPersonDocument(representer)
      return representer
    },
    showPersonDocument(person) {
      this.selectedPersonDocument = person
      this.showPersonDocumentModal = true
    },
    updatePerson(person) {
      person.display_amn = person.amn_id.includes('new_id') ? null : person.amn_id
      person.canFixPerson = this.formData.document_info?.status == '802' && ((person.amn_id && person.amn_id.includes('new_id')) || !person.code)

      if (person.role == 'procurator' || person.person_role == 'procurator') {
        this.formData.document_info?.procurators.map((item, key) => {
          if (item.id == person.id) {
            person.selectedCode = person.code || person.iltu_code
            this.$set(this.formData.document_info.procurators, key, person);
          }
        })
      } else if (person.role == 'jur-representer' || person.person_role == 'jur-representer') {
        this.formData.document_info?.pro_principals[0].jur_representers.map((item, key) => {
          if (item.id == person.id) {
            this.$set(this.formData.document_info?.pro_principals[0].jur_representers, key, person);
          }
        })
      } else if (person.role == 'principal' || person.person_role == 'principal') {
        this.formData.document_info?.principals.map((item, key) => {
          if (item.id == person.id) {
            this.$set(this.formData.document_info.principals, key, person);
          }
        })
      } else if (person.role == 'representitive' || person.person_role == 'representitive' || person.role == 'sub_representitive' || person.person_role == 'sub_representitive') {
        this.formData.document_info?.representitives.map((item, key) => {
          if (item.id == person.id) {
            this.$set(this.formData.document_info.representitives, key, person);
          }
        })
      }
      // this.reloadPersons = true
      // this.$nextTick(() => {
      //   this.reloadPersons = false
      // })
      this.showFixPerson = false
      this.selectedProcurator = {}
    },
    confirmDocumentAction(item) {
      let data = {}
      let url
      if (item.modalType === 'reject') {
        url = `in-journals/${this.getId}/reject`
        data = item
      } else if(item.modalType === 'register') {
         url = `in-journals/${this.getId}/approve`
         data.statement_files = this.selectedStatementDocuments.map(upload => upload.id)
         data.action = this.modalType
      } else {
        url = `in-journals/${this.getId}/approve`
        data.statement_files = this.selectedStatementDocuments.map(upload => upload.id)
        data.action = this.modalType == 'unsubscribe' ? 'deregister' : 'mark-person'
      }
      this.requestLoading = true
      this.$axios
        .post(url, data)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000110')
          this.showDocumentAction = false
          this.$router.push({
            name: 'journalReceived',
          })
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        }).finally(() => {
          this.requestLoading = false
        })
    },
    openModal(type) {
      this.modalType = type
      this.showDocumentAction = true
    },
    getMandatePdfFile(mandateId) {
      this.pageloading = true
      this.$axios
        .get(`mandates/${mandateId}/preview`)
        .then((res) => {
           if (res.data.files) {
            this.mainFiles = res.data.files
          } else {
            this.pdfFile = res.data
            this.pdfFile.original_filename = 'Peržiūra.pdf'
          }
        })
        .catch((err) => {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getData() {
      this.loading = true
      this.$axios
        .get(`in-journals/${this.getId}`)
        .then((res) => {
          this.formData = res.data.inJournal
          this.files.in_journal_file.file = this.formData.document_info.in_journal_file
          this.files.in_journal_file.original_filename = 'Peržiūra.pdf'
          this.files.mandate_file.file = this.formData.document_info.mandate_file
          this.files.mandate_file.original_filename = 'Peržiūra.pdf'
          this.attachments = res.data.inJournal.attachments
          if (this.formData.mandate_id){
            this.getMandatePdfFile(this.formData.mandate_id)
          }
          this.$emit('number', this.formData.document_info.journal_no)

          this.formData.document_info.pro_principals.map(item => {
            item.jur_representers.map(representer => {
              representer.display_amn = representer.amn_id.includes('new_id') ? '' : representer.amn_id
              representer.selectedCode = representer.code || representer.iltu_code
              representer.canFixPerson = this.formData.document_info?.status == '802' && ((representer.amn_id && representer.amn_id.includes('new_id')) || !representer.code)
              representer.canDelete = false
            })
          });

          this.formData.document_info.procurators.map(item => {
            item.display_amn = item.amn_id.includes('new_id') ? '' : item.amn_id
            item.selectedCode = item.code || item.iltu_code
            item.canFixPerson = this.formData.document_info?.status == '802' && ((item.amn_id && item.amn_id.includes('new_id')) || !item.code)
            item.canDelete = false
          });

          this.formData.document_info.principals.map(item => {
            item.display_amn = item.amn_id.includes('new_id') ? '' : item.amn_id
            item.selectedCode = item.code || item.iltu_code
            item.canFixPerson = this.formData.document_info?.status == '802' && ((item.amn_id && item.amn_id.includes('new_id') && item.type == 'FIZ') || (!item.code && item.type == 'FIZ'))
            item.canDelete = false
          });

          this.formData.document_info.representitives.map(item => {
            item.display_amn = item.amn_id.includes('new_id') ? '' : item.amn_id
            item.selectedCode = item.code || item.iltu_code
            item.canFixPerson = this.formData.document_info?.status == '802' && ((item.amn_id && item.amn_id.includes('new_id') && item.type == 'FIZ') || (!item.code && item.type == 'FIZ'))
            item.canDelete = false
          });
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          if(this.isDuplicate){
            this.showDuplicateModal = true
          }
          this.loading = false
        })
    },
    closeDuplicateModal(){
      this.showDuplicateModal = false
    },
    setDocumentsItem(item){
      item.canDownload = true
      return item
    },
    getItemSize(item){
      if(item.id){
        return this.bytesToSize(item.size)
      } else {
        return item.size
      }
    },
    download(item) {
      this.loading = true
      this.$axios
        .get(`uploads/${item.id}/download`)
        .then((res) => {
          this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        file.original_filename
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes == 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },

    handlePersonDocumentFilesUploaded(uploadedFiles) {
      console.log(uploadedFiles)
      this.selectedPersonDocument.person_documents.push(...uploadedFiles)
      // Files have been uploaded to backend, refresh the person document data
      // if (this.selectedPersonDocument && this.selectedPersonDocument.id) {
      //   // Refresh the person document to get updated file list
      //   this.$axios.get(`person-documents/${this.selectedPersonDocument.id}`)
      //     .then(response => {
      //       // Update the selected person document with fresh data
      //       Object.assign(this.selectedPersonDocument, response.data)
      //       this.$root.$emit('DATA_SUCCESS', 'Files uploaded successfully')
      //     })
      //     .catch(error => {
      //       console.error('Error refreshing person document:', error)
      //     })
      // }
    },

    handlePersonDocumentFileRemoved(fileId) {
      // File has been removed from backend, refresh the person document data
      // if (this.selectedPersonDocument && this.selectedPersonDocument.id) {
      //   // Refresh the person document to get updated file list
      //   this.$axios.get(`${this.getId}/uploads/person-document/${fileId}`)
      //     .then(response => {
      //       // Update the selected person document with fresh data
      //       this.$root.$emit('DATA_SUCCESS', 'File removed successfully')
      //     })
      //     .catch(error => {
      //       console.error('Error refreshing person document:', error)
      //     })
      // }
    },
  },
}
</script>

<style lang="scss" scoped></style>
